"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Force = exports.ForceUnitTexts = exports.ForceUnits = void 0;
const Quantity_1 = require("./Quantity");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
var ForceUnits;
(function (ForceUnits) {
    ForceUnits["norm"] = "N";
    ForceUnits["kN"] = "kN";
    ForceUnits["N"] = "N";
    ForceUnits["daN"] = "daN";
    ForceUnits["cN"] = "cN";
    ForceUnits["mN"] = "mN";
})(ForceUnits = exports.ForceUnits || (exports.ForceUnits = {}));
exports.ForceUnitTexts = {
    [ForceUnits.norm]: 'N',
    [ForceUnits.kN]: 'kN',
    [ForceUnits.N]: 'N',
    [ForceUnits.daN]: 'daN',
    [ForceUnits.cN]: 'cN',
    [ForceUnits.mN]: 'mN',
};
class Force extends Quantity_1.Quantity {
    constructor() {
        super(...arguments);
        this.className = 'Force';
        this.defaultUnit = 'N';
        this.unitTexts = exports.ForceUnitTexts;
    }
    static getUnitText(unit) {
        return exports.ForceUnitTexts[unit];
    }
    static fromJson(q) {
        if (!Object.values(ForceUnits).includes(q.Unit)) {
            throw new Error(`Force.fromJson: Unit not supported: ${q.Unit}`);
        }
        return new Force(q);
    }
    static N(v) {
        return new Force(v, ForceUnits.N);
    }
    static daN(v) {
        return new Force(v, ForceUnits.daN);
    }
    static kN(v) {
        return new Force(v, ForceUnits.kN);
    }
    static cN(v) {
        return new Force(v, ForceUnits.cN);
    }
    static mN(v) {
        return new Force(v, ForceUnits.mN);
    }
    set N(v) {
        this.value = v;
        this.unit = ForceUnits.N;
    }
    get N() {
        switch (this.unit) {
            case ForceUnits.N:
                return this.value;
            case ForceUnits.kN:
                return this.value * 1000;
            case ForceUnits.daN:
                return this.value * 10;
            case ForceUnits.cN:
                return this.value / 100;
            case ForceUnits.mN:
                return this.value / 1000;
        }
        throw new Error(`${this.className}.N: unknown unit ${this.unit}`);
    }
    set daN(v) {
        this.value = v;
        this.unit = ForceUnits.daN;
    }
    get daN() {
        return this.N / 10;
    }
    set kN(v) {
        this.value = v;
        this.unit = ForceUnits.kN;
    }
    get kN() {
        return this.N / 1000;
    }
    set cN(v) {
        this.value = v;
        this.unit = ForceUnits.cN;
    }
    get cN() {
        return this.N * 100;
    }
    set mN(v) {
        this.value = v;
        this.unit = ForceUnits.mN;
    }
    get mN() {
        return this.N * 1000;
    }
    clone() {
        return Force.fromJson(this.toJson());
    }
    getValue(unit) {
        switch (unit) {
            case 'default':
            case ForceUnits.N:
                return this.N;
            case ForceUnits.kN:
                return this.kN;
            case ForceUnits.daN:
                return this.daN;
            case ForceUnits.cN:
                return this.cN;
            case ForceUnits.mN:
                return this.mN;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(unit);
        }
        throw new Error(`${this.className}.getValue: Unit not supported: ${unit}`);
    }
}
exports.Force = Force;
Force.units = ForceUnits;
//# sourceMappingURL=Force.js.map